export default "__VITE_ASSET__0sNMZVRR__"